module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('b', [_vm._v("APPLICATION FOR EMPLOYMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("NAME:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Ishtar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("OCCUPATION:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Mother Goddess")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("MARITAL STATUS:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Mother/Harlot/Maiden/Wife")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('b', [_vm._v("PRESENT ADDERESS:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" In transit. (Temporary address; Syracuse, New York)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("AGE:")]), _c('span', {
    staticClass: "font1"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle",
      "width": "30%"
    },
    attrs: {
      "alt": "images",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" (E=MC"), _c('sup', [_vm._v("2")]), _vm._v(") (F=MA)?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("CHILDREN:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" same as above")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("EDUCATIONAL DATA:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" self-taught")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('b', [_vm._v("SOCIAL/COMMUNITY ACTIVITIES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Laying of cornerstones, setting of foundations, sacred prostitution (organizer, etc., etc…)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('b', [_vm._v("SPECIAL HONORS:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Star of David, Star of Solomon, Star of Bethlehem, Eastern Star (Grand Worthy Matron)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('b', [_vm._v("RECORD OF EMPLOYMENT:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" (Please record employment dates in chronological order)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("TITLE:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Queen of Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("PLACE OF EMPLOYMENT:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Galaxy")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DATES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" 4,800,000,000 - 9000 B.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('b', [_vm._v("MAJOR RESPONSIBILITIES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Fashioning stars, worlds, suns, people (everything, etc.) Prime moving")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("REASON FOR TERMINATION:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Project completed")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SALARY:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Original Title")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_c('b', [_vm._v("TITLE:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Angel of Death")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("PLACE OF EMPLOYMENT:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DATES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" April 9000 B.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("MAJOR RESPONSIBILITIES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" General conflagration, boils, etc…")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("REASON FOR TERMINATION:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Reorganization of Personnel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SALARY:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Peace/Quiet/Rest - Sabbatical")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_c('b', [_vm._v("TITLE:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Queen of Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("PLACE OF EMPLOYMENT:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" above")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DATES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" 9000 B.C. - 4501 B.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("MAJOR RESPONSIBILITIES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Birth, love, death, disease, seasons, etc.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("REASON FOR TERMINATION:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Company failed to maintain initial commitment")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SALARY:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Adoration/Worship/Respect")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_c('b', [_vm._v("TITLE:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Angel of Death")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("PLACE OF EMPLOYMENT:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" above")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DATES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" April 4501 B.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("MAJOR RESPONSIBILITIES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Flood engineer, Passover, Killing of 1st born, plagues")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("REASON FOR TERMINATION:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Cut-back in territory and personnel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SALARY:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Peace/Quiet")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_c('b', [_vm._v("TITLE:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Queen of Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("PLACE OF EMPLOYMENT:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("DATES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" 4501 B.C. - 1350 B.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("MAJOR RESPONSIBILITIES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Birth, love, death augury, disease, changing of seasons, alphabets")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("REASON FOR TERMINATION:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Personality differences (Moses & Monotheism)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SALARY:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Adoration, cakes and incense")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_c('b', [_vm._v("TITLE:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Whore of Babylon (unemployed)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("PLACE:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" wilderness")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("MAJOR RESPONSIBILITIES:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Birth, love, disease, changing of seasons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("REASON FOR TERMINATION:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Still working")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SALARY:")]), _c('span', {
    staticClass: "font1"
  }, [_vm._v(" Scorn and Calumny")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_c('b', [_vm._v("DO NOT WRITE BELOW. THIS SPACE FOR OFFICIAL USE ONLY")]), _c('span', {
    staticClass: "font1"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4467b6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_Application.vue
// module id = 78
// module chunks = 0